import { type IUIRuntime } from '@cian/mf-registry/browser';
import { type IMicrofrontendManifest } from '@cian/mf-registry/shared';

import { type IApplicationContext } from '@/app/shared/types/ApplicationContext';

import {
  type IGetEarlyAccessPaywallMicrofrontendRequest,
  type TGetEarlyAccessPaywallMicrofrontendResponse,
  fetchGetEarlyAccessPaywallMicrofrontend,
} from '@/repositories/manually-added/shared/early-access-paywall-frontend';

export type IFetchEarlyAccessPaywallParameters = IGetEarlyAccessPaywallMicrofrontendRequest;

export type TGetEarlyAccessPaywallMicrofrontendResult = {
  manifest: IMicrofrontendManifest;
} | null;

export async function fetchEarlyAccessPaywallMicrofrontend(
  context: IApplicationContext,
  parameters: IFetchEarlyAccessPaywallParameters = {},
): Promise<TGetEarlyAccessPaywallMicrofrontendResult> {
  const { httpApi, logger, microfrontendsRegistry } = context;

  try {
    const earlyAccessPaywallData: TGetEarlyAccessPaywallMicrofrontendResponse =
      await fetchGetEarlyAccessPaywallMicrofrontend({
        httpApi,
        parameters,
      });

    const image = microfrontendsRegistry.register(earlyAccessPaywallData.response.manifest);

    /* istanbul ignore next */
    if (typeof window !== 'undefined') {
      const runtime = image.runtimeStrict<IUIRuntime>(earlyAccessPaywallData.response.manifest.runtimeName);
      await runtime.ensure();
    }

    return {
      manifest: earlyAccessPaywallData.response.manifest,
    };
  } catch (ex) {
    logger.error(ex, { domain: 'shared.services.getEarlyAccessPaywallMicrofrontend' });

    return null;
  }
}
